<template>
  <IconSpinnerOutline :class-name="spinnerClasses" color="red" />
</template>
<script lang="ts" setup>
import IconSpinnerOutline from '@/components/icon/IconSpinnerOutline.vue'
import { computed } from 'vue'
const props = defineProps<{
  class?: string
  size?: 'small' | 'middle' | 'large' | 'default' | undefined
}>()

const spinnerClasses = computed(() => {
  switch (props.size) {
    case 'small':
      return '!h-8 !w-8'
    case 'middle':
      return '!h-20 !w-20'
    case 'large':
      return '!h-24 !w-24'
    case 'default':
    default:
      return '!h-16 !w-16'
  }
})
</script>
